import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import {
  Meal,
  MealTime,
  SalesByMenuCategoryResponse,
  MenuCategoryItem
} from '../../../../models';
import { Store } from '@ngxs/store';
import { FormBuilder, FormGroup } from '@angular/forms';
import { APP_STATE_TOKEN } from '../../../../store/app/app.state.model';
import { MealHelper } from '../../../../helpers';
import {
  GetRealtimeSalesByMenuCategory,
  PosManagerSelectors
} from '../../../../store/pos-manager';
import { ReactiveComponent } from '../../../../components/shared/reactive-component';
import { ViewSelectSnapshot } from '@ngxs-labs/select-snapshot';

@Component({
  selector: 'pos-total-sale-by-category',
  templateUrl: './total-sale-by-category.page.html',
  styleUrls: ['./total-sale-by-category.page.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TotalSaleByCategoryPage extends ReactiveComponent {
  @Input() selectedMealId: MealTime;
  @Input() selectedDateStr: string;
  @Input() selectedLocationId: number;

  @ViewSelectSnapshot(PosManagerSelectors.getRealtimeSalesByMenuCategory)
  salesByMenuCategory: SalesByMenuCategoryResponse | undefined;

  readonly MEALS: Meal[] = MealHelper.MEALS;
  form: FormGroup;
  sortColumn: 'name' | 'quantity' | 'total' = 'name';
  sortDirection: 'asc' | 'desc' = 'asc';

  constructor(
    private readonly store: Store,
    private readonly fb: FormBuilder,
    private readonly router: Router
  ) {
    super();
    const navigationState = this.router.getCurrentNavigation()?.extras?.state;
    if (navigationState) {
      this.selectedMealId =
        navigationState.selectedMealId || this.selectedMealId;
      this.selectedDateStr =
        navigationState.selectedDateStr || this.selectedDateStr;
      this.selectedLocationId =
        navigationState.selectedLocationId ||
        this.store.selectSnapshot(APP_STATE_TOKEN).device?.pos_location_id;
    }

    this.form = this.fb.group({
      selectedMealId: [this.selectedMealId],
      selectedLocationId: [
        this.selectedLocationId ||
          this.store.selectSnapshot(APP_STATE_TOKEN).device?.pos_location_id
      ]
    });
  }

  readonly MealTime = MealTime;

  trackByCategory(index: number, categoryName: string): string {
    return categoryName;
  }

  trackByItem(index: number, item: MenuCategoryItem): string {
    return item.name;
  }

  *onSubscribe() {
    this.fetchSalesData();

    yield this.form
      .get('selectedMealId')
      ?.valueChanges.subscribe((mealId: MealTime) => {
        this.fetchSalesData(mealId);
      });
  }

  private fetchSalesData(mealId?: MealTime) {
    const currentMealId = mealId || this.form.get('selectedMealId')?.value;

    if (currentMealId && this.selectedDateStr && this.selectedLocationId) {
      return this.store.dispatch(
        new GetRealtimeSalesByMenuCategory({
          date: this.selectedDateStr,
          pos_location: this.selectedLocationId,
          meal_id: currentMealId
        })
      );
    }
    return null;
  }

  toggleSort(column: 'name' | 'quantity' | 'total') {
    if (this.sortColumn === column) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }
  }
}
